import React from 'react';

interface Job {
  id: number;
  job_type: {
    title: string;
  };
  practice: {
    name: string;
    city: string;
    state: string;
  };
  position_types?: Array<{
    name: string;
  }>;
  created_at: string;
}

interface JobRecommendationsProps {
  jobs: Job[];
}

/**
 * JobRecommendations Component - Shows jobs matching candidate's profile
 */
export const JobRecommendations: React.FC<JobRecommendationsProps> = ({ jobs }) => {
  return (
    <div className="content-card">
      <div className="content-card__header">
        <h3><i className="fas fa-briefcase me-2"></i>Recommended Jobs</h3>
        {jobs.length > 0 && (
          <span className="badge-modern badge-modern--light">
            {jobs.length}
          </span>
        )}
      </div>
      <div className="content-card__body">
        {jobs.length === 0 ? (
          <div className="empty-state" style={{ padding: '2rem 1rem' }}>
            <div className="empty-state__icon">
              <i className="fas fa-search"></i>
            </div>
            <h4 className="empty-state__title" style={{ fontSize: '1rem' }}>
              No Recommendations Yet
            </h4>
            <p className="empty-state__description" style={{ fontSize: '0.85rem' }}>
              Complete your profile to get personalized job recommendations!
            </p>
            <a
              href="/profile/edit"
              className="btn-modern btn-modern--primary btn-modern--sm mt-2"
            >
              <i className="fas fa-user-edit me-2"></i>
              Update Profile
            </a>
          </div>
        ) : (
          <>
            <div className="d-flex flex-column gap-3">
              {jobs.map((job) => (
                <div
                  key={job.id}
                  style={{
                    padding: '0.75rem',
                    border: '1px solid #e8ecef',
                    borderRadius: '0.5rem',
                    transition: 'all 0.2s ease',
                    background: 'white',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(8, 94, 200, 0.03)';
                    e.currentTarget.style.borderColor = 'rgba(8, 94, 200, 0.2)';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'white';
                    e.currentTarget.style.borderColor = '#e8ecef';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6
                      className="mb-0 fw-semibold"
                      style={{ color: '#034ba6', fontSize: '0.9rem', lineHeight: '1.4' }}
                    >
                      {job.job_type.title}
                    </h6>
                    {job.position_types && job.position_types.length > 0 && (
                      <span
                        className="badge-modern badge-modern--primary"
                        style={{ fontSize: '0.7rem' }}
                      >
                        {job.position_types[0].name}
                      </span>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2 text-muted mb-2" style={{ fontSize: '0.8rem' }}>
                    <i className="fas fa-building" style={{ width: '12px' }}></i>
                    <span>{job.practice.name}</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 text-muted mb-3" style={{ fontSize: '0.8rem' }}>
                    <i className="fas fa-map-marker-alt" style={{ width: '12px' }}></i>
                    <span>
                      {job.practice.city}, {job.practice.state}
                    </span>
                  </div>
                  <a
                    href={`/jobs/${job.id}`}
                    className="btn btn-primary btn-rounded w-100"
                    style={{ fontSize: '0.85rem', padding: '0.5rem 1rem' }}
                  >
                    <i className="fas fa-eye me-2"></i>
                    View Job
                  </a>
                </div>
              ))}
            </div>

            {jobs.length >= 5 && (
              <a
                href="/jobs"
                className="btn-modern btn-modern--ghost btn-modern--block mt-3"
              >
                <i className="fas fa-search me-2"></i>
                Browse All Jobs
              </a>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default JobRecommendations;
